import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { listTagsSimple } from "../../services/tags.api";
import {
  getTicketTabCounts,
  filterGlobalTickets,
  searchGlobalTickets,
  closeAllTickets,
} from "../../services/tickets.api";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SocketContext } from "../../context/Socket/SocketContext";

// D8.27.3 — Lógica (26 estados + effects + handlers + API + socket) de TicketsManagerTabs (chat).
export default function useTicketsManagerTabs() {
  const history = useHistory();
  
  // ✅ FUNCIÓN PARA DETERMINAR LA PESTAÑA CORRECTA SEGÚN EL TIPO DE TICKET (NO UTILIZADA)
  // const getTabForTicket = (ticket) => {
  //   if (ticket.contact && ticket.contact.isGroup) {
  //     // ✅ GRUPOS: Solo van a "GRUPOS" o "CERRADOS"
  //     return ticket.status === "closed" ? "closed" : "groups";
  //   } else {
  //     // ✅ CONTACTOS INDIVIDUALES: Flujo normal
  //     return ticket.status;
  //   }
  // };

  // ✅ FUNCIÓN PARA MANEJAR CAMBIOS DE ESTADO DE TICKETS (NO UTILIZADA)
  // const handleTicketStatusChange = (ticket, newStatus) => {
  //   const currentTab = getTabForTicket(ticket);
  //   const newTab = getTabForTicket({ ...ticket, status: newStatus });
  //   
  //   // ✅ Si el ticket cambia de pestaña, actualizar la vista
  //   if (currentTab !== newTab) {
  //     if (newTab === "groups") {
  //       setTabOpen("groups");
  //     } else if (newTab === "closed") {
  //       setTabOpen("closed");
  //     }
  //   }
  // };
  


  
  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false); // ✅ AGREGADO: Para confirmación de cerrar tickets
  // ✅ ELIMINADO: duplicateTicketsModalOpen - Ya no se usa

  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  // const { profile } = user; // ✅ REMOVIDO: No se usa en este componente
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  // ✅ NUEVOS CONTADORES PARA PESTAÑAS MEJORADAS
  const [groupsCount, setGroupsCount] = useState(0);
  const [aiAgentsCount, setAiAgentsCount] = useState(0);
  const [allTicketsCount, setAllTicketsCount] = useState(0); // ✅ AGREGADO: Contador para vista "TODOS"

  // ✅ Inicializar con array vacío (sin filtro por defecto)
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);

  // ✅ ESTADO PARA EL BUSCADOR Y BOTONES DE ACCESO RÁPIDO
  const [localSearchParam, setLocalSearchParam] = useState("");
  const [searchOnMessages, setSearchOnMessages] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  
  // ✅ ESTADO PARA BÚSQUEDA GLOBAL
  const [globalSearchResults, setGlobalSearchResults] = useState(null);
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  
  // ✅ ESTADO PARA FILTROS
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [filterResults, setFilterResults] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const [tagFilterAnchorEl, setTagFilterAnchorEl] = useState(null);
  const [queueFilterAnchorEl, setQueueFilterAnchorEl] = useState(null);
  
  // ✅ ESTADO PARA CONTROLAR QUÉ BOTÓN DE ACCESO RÁPIDO ESTÁ ACTIVO
  const [activeQuickButton, setActiveQuickButton] = useState("open"); // "open", "closed", "all", "new", "resolve", "sort"
  const [closeTicketsOption, setCloseTicketsOption] = useState("open"); // "open", "pending", "both" - Opción seleccionada para cerrar tickets

  const tabCountsDebounceRef = useRef(null);
  const fetchTabCountsRef = useRef(async () => {});

  const fetchTabCounts = useCallback(async () => {
    if (!user?.companyId) return;
    try {
      const params = {
        includeAllTab: showAllTickets ? "true" : "false",
        searchParam: globalSearchResults ? "" : searchParam,
        searchOnMessages: searchOnMessages ? "true" : "false",
        sortAscending: "false"
      };
      if (filterResults && selectedQueueIds?.length > 0) {
        params.queueIds = JSON.stringify(selectedQueueIds);
      }
      const { data } = await getTicketTabCounts(params);
      if (typeof data.open === "number") setOpenCount(data.open);
      if (typeof data.pending === "number") setPendingCount(data.pending);
      if (typeof data.ai === "number") setAiAgentsCount(data.ai);
      if (typeof data.groups === "number") setGroupsCount(data.groups);
      if (showAllTickets && typeof data.all === "number") {
        setAllTicketsCount(data.all);
      } else if (!showAllTickets) {
        setAllTicketsCount(0);
      }
    } catch (e) {
      console.error("[TicketsManagerTabs] tab-counts:", e);
    }
  }, [
    user?.companyId,
    showAllTickets,
    globalSearchResults,
    searchParam,
    searchOnMessages,
    filterResults,
    selectedQueueIds
  ]);

  useEffect(() => {
    fetchTabCountsRef.current = fetchTabCounts;
  }, [fetchTabCounts]);

  useEffect(() => {
    fetchTabCounts();
  }, [fetchTabCounts]);

  // ✅ OBTENER SOCKET MANAGER EN EL NIVEL SUPERIOR
  const socketManager = useContext(SocketContext);

  // ✅ Socket: refresco único de contadores (misma fuente que GET /tickets/tab-counts) — evita drift + listas duplicadas
  useEffect(() => {
    let isMounted = true;

    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    const scheduleTabCountsRefresh = () => {
      if (!isMounted) return;
      clearTimeout(tabCountsDebounceRef.current);
      tabCountsDebounceRef.current = setTimeout(() => {
        fetchTabCountsRef.current();
      }, 1200);
    };

    const handleTicketUpdate = () => {
      scheduleTabCountsRefresh();
    };

    if (socket) {
      socket.on(`company-${companyId}-ticket`, handleTicketUpdate);
    }

    return () => {
      isMounted = false;
      clearTimeout(tabCountsDebounceRef.current);
      if (socket) {
        socket.off(`company-${companyId}-ticket`, handleTicketUpdate);
      }
    };
  }, [socketManager]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
  }, [tab]);

  // ✅ SINCRONIZAR ESTADO DEL BOTÓN ACTIVO CON LA PESTAÑA PRINCIPAL
  useEffect(() => {
    setActiveQuickButton(tab); // ✅ SINCRONIZAR CON PESTAÑA PRINCIPAL
  }, [tab]);

  // ✅ CARGAR TAGS AL MONTAR
  useEffect(() => {
    const loadTags = async () => {
      const companyId = user?.companyId;
      if (!companyId) return;
      try {
        const { data } = await listTagsSimple({ companyId });
        setTags(data || []);
      } catch (err) {
        console.error("Error cargando tags:", err);
      }
    };
    loadTags();
  }, [user?.companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ APLICAR FILTROS CUANDO CAMBIAN (con debounce)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Si hay búsqueda global activa, no aplicar filtros (prioridad a búsqueda)
      if (globalSearchResults) {
        setFilterResults(null);
        return;
      }
      
      // ✅ Verificar si hay filtros REALES (no valores por defecto)
      const hasQueueFilter = selectedQueueIds?.length > 0;
      const hasTagFilter = selectedTagIds?.length > 0;
      const hasFilters = hasQueueFilter || hasTagFilter;
      
      if (!hasFilters) {
        setFilterResults(null);
        return;
      }
      
      setFilterLoading(true);
      const params = {};
      if (hasQueueFilter) {
        params.queueIds = JSON.stringify(selectedQueueIds);
      }
      if (hasTagFilter) {
        params.tagIds = JSON.stringify(selectedTagIds);
      }
      
      filterGlobalTickets(params)
        .then(({ data }) => {
          setFilterResults(data);
          setFilterLoading(false);
        })
        .catch((error) => {
          console.error("❌ Error en filtrado global:", error);
          console.error("❌ Error response:", error.response?.data);
          setFilterLoading(false);
          setFilterResults(null);
        });
    }, 300); // Debounce de 300ms
    
    return () => clearTimeout(timeoutId);
  }, [selectedQueueIds, selectedTagIds, globalSearchResults]);

  let searchTimeout;


  // ✅ FUNCIONES PARA EL BUSCADOR Y BOTONES DE ACCESO RÁPIDO
  const handleNewSearch = async (e) => {
    const searchedTerm = e.target.value.toLowerCase();
    setLocalSearchParam(searchedTerm);

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setLocalSearchParam("");
      setSearchParam("");
      setGlobalSearchResults(null);
      setGlobalSearchLoading(false);
      // ✅ Si hay filtros activos, volver a aplicarlos
      if ((selectedQueueIds?.length > 0) || (selectedTagIds?.length > 0)) {
        // Se aplicarán automáticamente por el useEffect de filtros
      }
      return;
    }

    searchTimeout = setTimeout(async () => {
      // ✅ LLAMAR A API DE BÚSQUEDA GLOBAL
      setGlobalSearchLoading(true);
      try {
        const { data } = await searchGlobalTickets({
          searchParam: searchedTerm,
          searchOnMessages: searchOnMessages ? "true" : "false"
        });
        
        setGlobalSearchResults(data);
        setGlobalSearchLoading(false);
        // ✅ Limpiar filtros cuando hay búsqueda activa
        setFilterResults(null);
      } catch (error) {
        console.error("❌ Error en búsqueda global:", error);
        setGlobalSearchLoading(false);
        setGlobalSearchResults(null);
        // ✅ FALLBACK: Usar búsqueda normal si falla la global
        setSearchParam(searchedTerm);
      }
    }, 500);
  };

  const handleShowAllTickets = () => {
    setShowAllTickets(!showAllTickets);
    
    if (!showAllTickets) {
      // ✅ ACTIVAR VISTA "TODOS" - Cambiar a pestaña "all"
      setTab("open"); // Mantener en pestaña principal "open"
      setTabOpen("all"); // Cambiar a pestaña interna "all"
      setActiveQuickButton("all");
    } else {
      // ✅ DESACTIVAR VISTA "TODOS" - Volver a vista normal
      setTab("open");
      setTabOpen("open"); // Volver a pestaña "open"
      setActiveQuickButton("open");
    }
  };

  const handleNewTicket = () => {
    setNewTicketModalOpen(true); // ✅ ABRIR MODAL PARA CREAR NUEVO TICKET
  };

  const handleResolveTickets = () => {
    setConfirmationModalOpen(true); // ✅ MOSTRAR MODAL DE CONFIRMACIÓN
  };

  // ✅ FUNCIÓN PARA VERIFICAR SI HAY TICKETS PARA CERRAR
  const hasTicketsToClose = () => {
    if (closeTicketsOption === "open") {
      return openCount > 0;
    } else if (closeTicketsOption === "pending") {
      return pendingCount > 0;
    } else if (closeTicketsOption === "both") {
      return (openCount + pendingCount) > 0;
    }
    return false;
  };

  // ✅ FUNCIÓN PARA CONFIRMAR CERRAR TODOS LOS TICKETS
  const handleConfirmCloseAllTickets = async () => {
    // ✅ VALIDACIÓN DE SEGURIDAD: Verificar que hay tickets para cerrar
    if (!hasTicketsToClose()) {
      console.warn("⚠️ No hay tickets para cerrar según la opción seleccionada");
      return; // ✅ NO HACER NADA SI NO HAY TICKETS
    }

    console.log("🎮 CONFIRMANDO CERRAR TODOS LOS TICKETS - Opción seleccionada:", closeTicketsOption);
    setConfirmationModalOpen(false); // ✅ CERRAR MODAL
    
    try {
      // ✅ DETERMINAR QUÉ STATUS CERRAR SEGÚN LA OPCIÓN SELECCIONADA
      let statusesToClose = [];
      
      if (closeTicketsOption === "open") {
        statusesToClose = ["open"];
      } else if (closeTicketsOption === "pending") {
        statusesToClose = ["pending"];
      } else if (closeTicketsOption === "both") {
        statusesToClose = ["open", "pending"];
      }
      
      // ✅ FILTRAR STATUS QUE REALMENTE TIENEN TICKETS
      const statusesWithTickets = statusesToClose.filter(status => {
        if (status === "open") return openCount > 0;
        if (status === "pending") return pendingCount > 0;
        return false;
      });

      // ✅ SI NO HAY TICKETS EN NINGÚN STATUS, NO HACER NADA
      if (statusesWithTickets.length === 0) {
        console.warn("⚠️ No hay tickets para cerrar en ningún status seleccionado");
        return;
      }
      
      console.log("🎮 CERRANDO TICKETS CON STATUS:", statusesWithTickets);
      
      // ✅ CERRAR TICKETS PARA CADA STATUS SELECCIONADO QUE TENGA TICKETS
      const closePromises = statusesWithTickets.map(status =>
        closeAllTickets({ status })
      );
      
      await Promise.all(closePromises);
      
      console.log("✅ TODOS LOS TICKETS CERRADOS EXITOSAMENTE");
      
      // ✅ ACTUALIZAR CONTADORES
      if (closeTicketsOption === "open" || closeTicketsOption === "both") {
        setOpenCount(0);
      }
      if (closeTicketsOption === "pending" || closeTicketsOption === "both") {
        setPendingCount(0);
      }
      
      // ✅ CAMBIAR A PESTAÑA DE CERRADOS PARA VER EL RESULTADO
      setTab("closed");
      setActiveQuickButton("closed");
      
    } catch (error) {
      console.error("❌ ERROR AL CERRAR TICKETS:", error);
      // ✅ AQUÍ PODRÍAS AGREGAR UN TOAST DE ERROR SI LO DESEAS
    }
  };

  const handleOpenTickets = () => {
    setTab("open"); // ✅ CAMBIAR A PESTAÑA PRINCIPAL "ABIERTOS"
    setActiveQuickButton("open"); // ✅ MARCAR BOTÓN COMO ACTIVO
  };

  const handleClosedTickets = () => {
    setTab("closed"); // ✅ CAMBIAR A PESTAÑA PRINCIPAL "RESUELTOS"
    setActiveQuickButton("closed"); // ✅ MARCAR BOTÓN COMO ACTIVO
  };


  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  // ✅ FUNCIÓN PARA NAVEGAR A UN TICKET DESDE FILTROS/BÚSQUEDA
  const handleSelectTicket = (ticket) => {
    if (ticket && ticket.uuid) {
      history.push(`/tickets/${ticket.uuid}`);
    } else if (ticket && ticket.id) {
      history.push(`/tickets/${ticket.id}`);
    }
  };

  // ✅ COMENTADO: handleChangeTab ya no se usa porque las pestañas principales están ocultas
  // const handleChangeTab = (e, newValue) => {
  //   setTab(newValue);
  // };

  const applyPanelStyle = (status) => {
    // ✅ Permitir que siempre mantengan su tamaño natural para el scroll
    // Solo controlar la visibilidad con display en el div padre
    return {
      height: "100%",
      width: "100%"
    };
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };


  const handleCloseTransferModal = () => {
    setTransferTicketModalOpen(false);
  };

  return {
    activeQuickButton,
    aiAgentsCount,
    allTicketsCount,
    applyPanelStyle,
    closeTicketsOption,
    confirmationModalOpen,
    fetchTabCounts,
    fetchTabCountsRef,
    filterLoading,
    filterPanelOpen,
    filterResults,
    globalSearchLoading,
    globalSearchResults,
    groupsCount,
    handleChangeTabOpen,
    handleCloseOrOpenTicket,
    handleCloseTransferModal,
    handleClosedTickets,
    handleConfirmCloseAllTickets,
    handleNewSearch,
    handleNewTicket,
    handleOpenTickets,
    handleResolveTickets,
    handleSelectTicket,
    handleShowAllTickets,
    hasTicketsToClose,
    history,
    localSearchParam,
    newTicketModalOpen,
    openCount,
    pendingCount,
    queueFilterAnchorEl,
    searchInputRef,
    searchOnMessages,
    searchParam,
    selectedQueueIds,
    selectedTagIds,
    setActiveQuickButton,
    setAiAgentsCount,
    setAllTicketsCount,
    setCloseTicketsOption,
    setConfirmationModalOpen,
    setFilterLoading,
    setFilterPanelOpen,
    setFilterResults,
    setGlobalSearchLoading,
    setGlobalSearchResults,
    setGroupsCount,
    setLocalSearchParam,
    setNewTicketModalOpen,
    setOpenCount,
    setPendingCount,
    setQueueFilterAnchorEl,
    setSearchOnMessages,
    setSearchParam,
    setSelectedQueueIds,
    setSelectedTagIds,
    setShowAllTickets,
    setTab,
    setTabOpen,
    setTagFilterAnchorEl,
    setTags,
    setTransferTicketModalOpen,
    showAllTickets,
    socketManager,
    tab,
    tabCountsDebounceRef,
    tabOpen,
    tagFilterAnchorEl,
    tags,
    transferTicketModalOpen,
    user,
  };
}
